import { useContext } from 'react'
import { RadioGroup, styled } from '@mui/material'
import { FolderFilterContext } from './context'
import { FolderTreeItem } from './folder-filter-tree-item'

const ScrollContainer = styled('div')`
  overflow-y: scroll;
  max-height: 350px;
`

export const FolderTree = () => {
  const { treeState, selectedFolder, onFolderSelected } = useContext(FolderFilterContext)

  return (
    <ScrollContainer>
      <RadioGroup
        value={selectedFolder}
        onChange={e => {
          onFolderSelected(e.target.value)
        }}
      >
        <FolderTreeItem folder={treeState} />
      </RadioGroup>
    </ScrollContainer>
  )
}
